// extracted by mini-css-extract-plugin
module.exports = {"giphy_player":"_31n5M","giphyPlayer":"_31n5M"};